import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CheckoutCardForm from "./CheckoutCardForm";
// import CheckoutEbanForm from "./CheckoutEbanForm";

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

export default function CheckoutForm() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper className={classes.root}>
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                centered
            >
                <Tab label="Carte Bancaire" />
                {/*<Tab label="Virement SEPA"/>*/}
            </Tabs>
            {value === 0 && <CheckoutCardForm/>}
            {/*{value === 1 && <CheckoutEbanForm/>}*/}
        </Paper>
    );
}